export const mergeMessagesById = (currentMessages, incomingMessages, chatRoomId) => {
  const merged = new Map();

  [...(currentMessages || []), ...(incomingMessages || [])].forEach((message) => {
    if (!message?.id) return;
    if (chatRoomId && message.chatRoomID !== chatRoomId) return;
    merged.set(message.id, message);
  });

  return Array.from(merged.values()).sort((a, b) => (
    new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
  ));
};
